module.exports = __webpack_public_path__ + "static/media/correcoes-2.075b10e7.png";